'use strict';

(function () {
    /** @namespace Fotobook.souvenir */
    Fotobook.souvenir = {

        // todo не учитывает форзац
        // todo делать эту функцию в каждом типе продуктов - оверхед. решить в общем случае. пока что так...
        getPrintPageNum($page) {
            const region = Fotobook.productRegions.getByCode($page.attr('data-page_type'));
            return region ? region.name : 'flyleaf';
        },
    };
})();
